<app-page-messages [message]="pageMessage"></app-page-messages>
<vue-panel
  *ngIf="fileAvailable"
  [title]="downloadMessage | translate: undefined: [fileName] | async" style="text-align: center; margin: 15px;">
  <a
    href="#"
    (click)="getAndOpenFile($event)"
    target="_blank"
    *ngIf="fileAvailable"
    class="btn btn-sm btn-primary btn-center"
  >
    <span>{{ "button.DownloadFile" | translate | async }}</span>
  </a>
</vue-panel>
